var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoleSubuserLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9792 10.4456C16.3877 10.4456 17.5162 9.29702 17.5162 7.87416C17.5162 6.45131 16.3877 5.30273 14.9792 5.30273C13.5707 5.30273 12.4338 6.45131 12.4338 7.87416C12.4338 9.29702 13.5707 10.4456 14.9792 10.4456ZM8.19135 10.4456C9.59983 10.4456 10.7283 9.29702 10.7283 7.87416C10.7283 6.45131 9.59983 5.30273 8.19135 5.30273C6.78286 5.30273 5.64589 6.45131 5.64589 7.87416C5.64589 9.29702 6.78286 10.4456 8.19135 10.4456ZM8.19135 12.1599C6.21438 12.1599 2.25195 13.1627 2.25195 15.1599V17.3027H14.1307V15.1599C14.1307 13.1627 10.1683 12.1599 8.19135 12.1599ZM14.9792 12.1599C14.7332 12.1599 14.4532 12.177 14.1562 12.2027C15.1404 12.9227 15.8277 13.8913 15.8277 15.1599V17.3027H20.9186V15.1599C20.9186 13.1627 16.9562 12.1599 14.9792 12.1599Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleSubuserLogo);
export default __webpack_public_path__ + "static/media/role-subuser-logo.2aa60fae432afe883793bce4c19d0fa8.svg";
export { ForwardRef as ReactComponent };